export const siteModalsStrings = [
  'accountBalances',
  'accountLocked',
  'accountRestricted',
  'accountUnlocked',
  'acknowledge-partial-reg',
  'category',
  'complete-registration',
  'confirmMobileNumberDelete',
  'demoPlayLaunchAlert',
  'demoPlayRegPrompt',
  'gameShare',
  'login',
  'newNotification',
  'numberChangeLogoutAlert',
  'passwordResetEnterOtp',
  'passwordResetStepOne',
  'passwordResetStepSuccess',
  'progressiveJackpotsMoreInfo',
  'register',
  'realPlayLaunchAlert',
  'registrationFullCompletion',
  'registrationPartialCompletion',
  'registrationVerifyName',
  'registrationWelcomeOffer',
  'rGExclusionMessage',
  'rGLimitsMessage',
  'search',
  'sessionLimitExceeded',
  'sign-up',
  'sumSubPasswordResetLoggedOutChangePassword',
  'sumSubPasswordResetLoggedOutChangeNumber',
  'sumSubPasswordResetLoggedOutChangeNumberSuccess',
  'sumSubPasswordResetLoggedOutChangePasswordSuccess',
  'sumSubPasswordResetLoggedOutLivenessCheck',
  'switchToRealPlayPrompt',
  'transactionAssignBonus',
  'transactionsFilter',
  'verifyNumberOtp',
  'wagerLimitExceeded',
  'withdrawalAlert',
] as const;

export const AccountModalsStrings = [
  'account-settings',
  'gifts-and-offers',
  'deposit',
  'document-verification',
  'history',
  'logout',
  'jpc-rewards',
  'bonus-wallet',
  'my-big-wins',
  'password-management',
  'password-management-success',
  'personal-details',
  'responsible-gaming',
  'settings',
  'teller',
  'transaction-summary',
  'transaction-summary-detail',
  'withdrawal',
  'gifts-offers',
] as const;

export type AccountModals = (typeof AccountModalsStrings)[number];
export type Modals = (typeof siteModalsStrings)[number];
